/**
 * @generated SignedSource<<b7ef3dd78f617ba20e117903caea5f68>>
 * @relayHash dff560da6b44e8698cb7db6cce996d50
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ec8ebec42ce3a627014ff3055a722125ee7a7a44b01f69e101974c5c5fe01543

import type { ConcreteRequest, Query } from 'relay-runtime';
export type triggerWithCustomFieldsJSWGlobalIssueCreateQuery$variables = {
  boardId: string;
  isCMP?: boolean | null | undefined;
};
export type triggerWithCustomFieldsJSWGlobalIssueCreateQuery$data = {
  readonly boardScope: {
    readonly globalCardCreateAdditionalFields: {
      readonly boardIssueListKey: string | null | undefined;
      readonly rankCustomFieldId: string | null | undefined;
      readonly sprintCustomFieldId: string | null | undefined;
    } | null | undefined;
  };
};
export type triggerWithCustomFieldsJSWGlobalIssueCreateQuery = {
  response: triggerWithCustomFieldsJSWGlobalIssueCreateQuery$data;
  variables: triggerWithCustomFieldsJSWGlobalIssueCreateQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "boardId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isCMP"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "boardId",
    "variableName": "boardId"
  },
  {
    "kind": "Variable",
    "name": "isCMP",
    "variableName": "isCMP"
  }
],
v2 = {
  "concreteType": "GlobalCardCreateAdditionalFields",
  "kind": "LinkedField",
  "name": "globalCardCreateAdditionalFields",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "sprintCustomFieldId"
    },
    {
      "kind": "ScalarField",
      "name": "rankCustomFieldId"
    },
    {
      "kind": "ScalarField",
      "name": "boardIssueListKey"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "triggerWithCustomFieldsJSWGlobalIssueCreateQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "args": (v1/*: any*/),
          "concreteType": "BoardScope",
          "kind": "LinkedField",
          "name": "boardScope",
          "plural": false,
          "selections": [
            (v2/*: any*/)
          ]
        },
        "action": "THROW",
        "path": "boardScope"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "triggerWithCustomFieldsJSWGlobalIssueCreateQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "BoardScope",
        "kind": "LinkedField",
        "name": "boardScope",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "ScalarField",
            "name": "id"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "ec8ebec42ce3a627014ff3055a722125ee7a7a44b01f69e101974c5c5fe01543",
    "metadata": {},
    "name": "triggerWithCustomFieldsJSWGlobalIssueCreateQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "96d35f31f30c5edc94e3d721f9444ea0";

export default node;
